// extracted by mini-css-extract-plugin
export default {"wrapper":"_ce005c83","textWrapper":"_6080abbe","label":"_293bda56"};